import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const getPOListQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getPOList, cleanedData);
};

const getPOList = (data) => {
  return useQuery(['getPOList', data],
    () => getPOListQuery(data), { refetchOnWindowFocus: false });
};

export default getPOList;
